<template>
  <div class="py-6">
    <div class="relative flex items-center space-x-6 pl-6">
      <button
        class="h-8 w-8 text-gray-300 hover:text-gray-500"
        @click="$emit('close')"
        v-html="$icons.arrow_left"
      ></button>
      <h1 class="whitespace-nowrap text-lg font-medium text-gray-100 dark:text-gray-300 md:text-2xl">
        {{ title }}
      </h1>
      <p class="text-xs text-gray-400">{{ description }}</p>
    </div>
    <swiper class="overflow-visible px-3 pt-6 md:px-6" :options="options">
      <swiper-slide v-for="(item, $index) in products" :key="$index">
        <card-marketplace
          :class="details_index == $index ? 'relative z-50' : ''"
          class="mr-6 border-none"
          :product="item"
          :strategy="item.strategies[0]"
          :favorite="favorite.includes(item.strategies[0].strategy_id)"
          @click.native="Details(item.strategies[0].strategy_id, item.product_id, $index)"
      /></swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
    CardMarketplace: () => import("@/app/modules/marketplace/components/products/card/marketplace-card.component.vue"),
  },

  data() {
    return {
      active_details: false,
      options: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 25,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
      },
    };
  },
  props: {
    products: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
    },

    description: {
      type: String,
    },

    details_index: {
      type: Number,
    },
  },

  methods: {
    Details(strategy, product, index) {
      let params = {
        strategy: strategy,
        product: product,
        index: index,
      };
      // console.log(params);
      this.$emit("details", params);
    },
  },

  computed: {
    ...mapState({
      favorite: (state) => state.marketplace.favorite,
    }),
  },
};
</script>
